import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { OffersHistoryFragmentDoc } from '../../../streaming-offers-history/graphql/fragments/OffersHistory.fragment';
import { TitleOfferFragmentDoc, FastOfferFragmentDoc } from './Offer.fragment';
export type BuyBoxOffers_Episode_Fragment = {
	__typename: 'Episode';
	offerCount: number;
	maxOfferUpdatedAt?: any | null;
	totalPackages: number;
	offersHistory: Array<{
		__typename: 'OfferHistory';
		id: string;
		country: any;
		dateRanges: Array<{ __typename?: 'DateRange'; end: any; start: any }>;
		package: {
			__typename?: 'Package';
			icon: string;
			id: string;
			iconWide: string;
			clearName: string;
			packageId: number;
			monetizationTypes: Array<Types.MonetizationType>;
		};
	}>;
	flatrate: Array<{
		__typename?: 'Offer';
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	dvdBluray: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	buy: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	rent: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	free: Array<{
		__typename?: 'Offer';
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	fast: Array<{
		__typename?: 'Offer';
		availableTo?: any | null;
		availableFromTime?: any | null;
		availableToTime?: any | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	bundles: Array<{
		__typename?: 'PromotedBundleEdge';
		promotionUrl: string;
		node: {
			__typename?: 'Bundle';
			id: string;
			clearName: string;
			icon: string;
			technicalName: string;
			bundleId: number;
			shortName: string;
			packages: Array<{
				__typename?: 'Package';
				icon: string;
				id: string;
				iconWide: string;
				clearName: string;
				packageId: number;
			}>;
		};
		offer: {
			__typename?: 'Offer';
			id: string;
			presentationType: Types.PresentationType;
			monetizationType: Types.MonetizationType;
			newElementCount?: number | null;
			retailPrice?: string | null;
			retailPriceValue?: number | null;
			userLocalCurrency?: string | null;
			retailPriceConverted?: string | null;
			currency?: string | null;
			lastChangeRetailPriceValue?: number | null;
			type: Types.OfferType;
			country: any;
			standardWebURL?: string | null;
			preAffiliatedStandardWebURL?: string | null;
			streamUrl?: string | null;
			streamUrlExternalPlayer?: string | null;
			elementCount?: number | null;
			availableTo?: any | null;
			subtitleLanguages: Array<any>;
			videoTechnology: Array<Types.VideoTechnology>;
			audioTechnology: Array<Types.AudioTechnology>;
			audioLanguages: Array<any>;
			updatedAt?: any | null;
			mediaDealId?: number | null;
			package: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				clearName: string;
				shortName: string;
				technicalName: string;
				icon: string;
				iconWide: string;
				planOffers: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
					retailPriceConverted?: string | null;
					children: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
					}>;
				}>;
			};
			plans: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
	}>;
};

export type BuyBoxOffers_Movie_Fragment = {
	__typename: 'Movie';
	offerCount: number;
	maxOfferUpdatedAt?: any | null;
	totalPackages: number;
	promotedBundles: Array<{
		__typename?: 'PromotedBundleEdge';
		promotionUrl: string;
		node: {
			__typename?: 'Bundle';
			id: string;
			clearName: string;
			icon: string;
			technicalName: string;
			bundleId: number;
			shortName: string;
			packages: Array<{
				__typename?: 'Package';
				icon: string;
				id: string;
				clearName: string;
				packageId: number;
				iconWide: string;
			}>;
		};
		offer: {
			__typename?: 'Offer';
			id: string;
			presentationType: Types.PresentationType;
			monetizationType: Types.MonetizationType;
			newElementCount?: number | null;
			retailPrice?: string | null;
			retailPriceValue?: number | null;
			userLocalCurrency?: string | null;
			retailPriceConverted?: string | null;
			currency?: string | null;
			lastChangeRetailPriceValue?: number | null;
			type: Types.OfferType;
			country: any;
			standardWebURL?: string | null;
			preAffiliatedStandardWebURL?: string | null;
			streamUrl?: string | null;
			streamUrlExternalPlayer?: string | null;
			elementCount?: number | null;
			availableTo?: any | null;
			subtitleLanguages: Array<any>;
			videoTechnology: Array<Types.VideoTechnology>;
			audioTechnology: Array<Types.AudioTechnology>;
			audioLanguages: Array<any>;
			updatedAt?: any | null;
			mediaDealId?: number | null;
			package: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				clearName: string;
				shortName: string;
				technicalName: string;
				icon: string;
				iconWide: string;
				planOffers: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
					retailPriceConverted?: string | null;
					children: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
					}>;
				}>;
			};
			plans: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
	}>;
	promotedOffers: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	offersHistory: Array<{
		__typename: 'OfferHistory';
		id: string;
		country: any;
		dateRanges: Array<{ __typename?: 'DateRange'; end: any; start: any }>;
		package: {
			__typename?: 'Package';
			icon: string;
			id: string;
			iconWide: string;
			clearName: string;
			packageId: number;
			monetizationTypes: Array<Types.MonetizationType>;
		};
	}>;
	flatrate: Array<{
		__typename?: 'Offer';
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	dvdBluray: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	buy: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	rent: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	free: Array<{
		__typename?: 'Offer';
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	fast: Array<{
		__typename?: 'Offer';
		availableTo?: any | null;
		availableFromTime?: any | null;
		availableToTime?: any | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	bundles: Array<{
		__typename?: 'PromotedBundleEdge';
		promotionUrl: string;
		node: {
			__typename?: 'Bundle';
			id: string;
			clearName: string;
			icon: string;
			technicalName: string;
			bundleId: number;
			shortName: string;
			packages: Array<{
				__typename?: 'Package';
				icon: string;
				id: string;
				iconWide: string;
				clearName: string;
				packageId: number;
			}>;
		};
		offer: {
			__typename?: 'Offer';
			id: string;
			presentationType: Types.PresentationType;
			monetizationType: Types.MonetizationType;
			newElementCount?: number | null;
			retailPrice?: string | null;
			retailPriceValue?: number | null;
			userLocalCurrency?: string | null;
			retailPriceConverted?: string | null;
			currency?: string | null;
			lastChangeRetailPriceValue?: number | null;
			type: Types.OfferType;
			country: any;
			standardWebURL?: string | null;
			preAffiliatedStandardWebURL?: string | null;
			streamUrl?: string | null;
			streamUrlExternalPlayer?: string | null;
			elementCount?: number | null;
			availableTo?: any | null;
			subtitleLanguages: Array<any>;
			videoTechnology: Array<Types.VideoTechnology>;
			audioTechnology: Array<Types.AudioTechnology>;
			audioLanguages: Array<any>;
			updatedAt?: any | null;
			mediaDealId?: number | null;
			package: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				clearName: string;
				shortName: string;
				technicalName: string;
				icon: string;
				iconWide: string;
				planOffers: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
					retailPriceConverted?: string | null;
					children: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
					}>;
				}>;
			};
			plans: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
	}>;
};

export type BuyBoxOffers_Season_Fragment = {
	__typename: 'Season';
	offerCount: number;
	maxOfferUpdatedAt?: any | null;
	totalPackages: number;
	promotedBundles: Array<{
		__typename?: 'PromotedBundleEdge';
		promotionUrl: string;
		node: {
			__typename?: 'Bundle';
			id: string;
			clearName: string;
			icon: string;
			technicalName: string;
			bundleId: number;
			shortName: string;
			packages: Array<{
				__typename?: 'Package';
				icon: string;
				id: string;
				clearName: string;
				packageId: number;
				iconWide: string;
			}>;
		};
		offer: {
			__typename?: 'Offer';
			id: string;
			presentationType: Types.PresentationType;
			monetizationType: Types.MonetizationType;
			newElementCount?: number | null;
			retailPrice?: string | null;
			retailPriceValue?: number | null;
			userLocalCurrency?: string | null;
			retailPriceConverted?: string | null;
			currency?: string | null;
			lastChangeRetailPriceValue?: number | null;
			type: Types.OfferType;
			country: any;
			standardWebURL?: string | null;
			preAffiliatedStandardWebURL?: string | null;
			streamUrl?: string | null;
			streamUrlExternalPlayer?: string | null;
			elementCount?: number | null;
			availableTo?: any | null;
			subtitleLanguages: Array<any>;
			videoTechnology: Array<Types.VideoTechnology>;
			audioTechnology: Array<Types.AudioTechnology>;
			audioLanguages: Array<any>;
			updatedAt?: any | null;
			mediaDealId?: number | null;
			package: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				clearName: string;
				shortName: string;
				technicalName: string;
				icon: string;
				iconWide: string;
				planOffers: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
					retailPriceConverted?: string | null;
					children: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
					}>;
				}>;
			};
			plans: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
	}>;
	promotedOffers: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	offersHistory: Array<{
		__typename: 'OfferHistory';
		id: string;
		country: any;
		dateRanges: Array<{ __typename?: 'DateRange'; end: any; start: any }>;
		package: {
			__typename?: 'Package';
			icon: string;
			id: string;
			iconWide: string;
			clearName: string;
			packageId: number;
			monetizationTypes: Array<Types.MonetizationType>;
		};
	}>;
	flatrate: Array<{
		__typename?: 'Offer';
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	dvdBluray: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	buy: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	rent: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	free: Array<{
		__typename?: 'Offer';
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	fast: Array<{
		__typename?: 'Offer';
		availableTo?: any | null;
		availableFromTime?: any | null;
		availableToTime?: any | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	bundles: Array<{
		__typename?: 'PromotedBundleEdge';
		promotionUrl: string;
		node: {
			__typename?: 'Bundle';
			id: string;
			clearName: string;
			icon: string;
			technicalName: string;
			bundleId: number;
			shortName: string;
			packages: Array<{
				__typename?: 'Package';
				icon: string;
				id: string;
				iconWide: string;
				clearName: string;
				packageId: number;
			}>;
		};
		offer: {
			__typename?: 'Offer';
			id: string;
			presentationType: Types.PresentationType;
			monetizationType: Types.MonetizationType;
			newElementCount?: number | null;
			retailPrice?: string | null;
			retailPriceValue?: number | null;
			userLocalCurrency?: string | null;
			retailPriceConverted?: string | null;
			currency?: string | null;
			lastChangeRetailPriceValue?: number | null;
			type: Types.OfferType;
			country: any;
			standardWebURL?: string | null;
			preAffiliatedStandardWebURL?: string | null;
			streamUrl?: string | null;
			streamUrlExternalPlayer?: string | null;
			elementCount?: number | null;
			availableTo?: any | null;
			subtitleLanguages: Array<any>;
			videoTechnology: Array<Types.VideoTechnology>;
			audioTechnology: Array<Types.AudioTechnology>;
			audioLanguages: Array<any>;
			updatedAt?: any | null;
			mediaDealId?: number | null;
			package: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				clearName: string;
				shortName: string;
				technicalName: string;
				icon: string;
				iconWide: string;
				planOffers: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
					retailPriceConverted?: string | null;
					children: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
					}>;
				}>;
			};
			plans: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
	}>;
};

export type BuyBoxOffers_Show_Fragment = {
	__typename: 'Show';
	offerCount: number;
	maxOfferUpdatedAt?: any | null;
	totalPackages: number;
	promotedBundles: Array<{
		__typename?: 'PromotedBundleEdge';
		promotionUrl: string;
		node: {
			__typename?: 'Bundle';
			id: string;
			clearName: string;
			icon: string;
			technicalName: string;
			bundleId: number;
			shortName: string;
			packages: Array<{
				__typename?: 'Package';
				icon: string;
				id: string;
				clearName: string;
				packageId: number;
				iconWide: string;
			}>;
		};
		offer: {
			__typename?: 'Offer';
			id: string;
			presentationType: Types.PresentationType;
			monetizationType: Types.MonetizationType;
			newElementCount?: number | null;
			retailPrice?: string | null;
			retailPriceValue?: number | null;
			userLocalCurrency?: string | null;
			retailPriceConverted?: string | null;
			currency?: string | null;
			lastChangeRetailPriceValue?: number | null;
			type: Types.OfferType;
			country: any;
			standardWebURL?: string | null;
			preAffiliatedStandardWebURL?: string | null;
			streamUrl?: string | null;
			streamUrlExternalPlayer?: string | null;
			elementCount?: number | null;
			availableTo?: any | null;
			subtitleLanguages: Array<any>;
			videoTechnology: Array<Types.VideoTechnology>;
			audioTechnology: Array<Types.AudioTechnology>;
			audioLanguages: Array<any>;
			updatedAt?: any | null;
			mediaDealId?: number | null;
			package: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				clearName: string;
				shortName: string;
				technicalName: string;
				icon: string;
				iconWide: string;
				planOffers: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
					retailPriceConverted?: string | null;
					children: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
					}>;
				}>;
			};
			plans: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
	}>;
	promotedOffers: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	offersHistory: Array<{
		__typename: 'OfferHistory';
		id: string;
		country: any;
		dateRanges: Array<{ __typename?: 'DateRange'; end: any; start: any }>;
		package: {
			__typename?: 'Package';
			icon: string;
			id: string;
			iconWide: string;
			clearName: string;
			packageId: number;
			monetizationTypes: Array<Types.MonetizationType>;
		};
	}>;
	flatrate: Array<{
		__typename?: 'Offer';
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	dvdBluray: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	buy: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	rent: Array<{
		__typename?: 'Offer';
		offerSeasons?: Array<string> | null;
		minRetailPrice?: string | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	free: Array<{
		__typename?: 'Offer';
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		availableTo?: any | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	fast: Array<{
		__typename?: 'Offer';
		availableTo?: any | null;
		availableFromTime?: any | null;
		availableToTime?: any | null;
		id: string;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		userLocalCurrency?: string | null;
		retailPriceConverted?: string | null;
		currency?: string | null;
		lastChangeRetailPriceValue?: number | null;
		type: Types.OfferType;
		country: any;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		elementCount?: number | null;
		subtitleLanguages: Array<any>;
		videoTechnology: Array<Types.VideoTechnology>;
		audioTechnology: Array<Types.AudioTechnology>;
		audioLanguages: Array<any>;
		updatedAt?: any | null;
		mediaDealId?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			icon: string;
			iconWide: string;
			planOffers: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
		plans: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
	bundles: Array<{
		__typename?: 'PromotedBundleEdge';
		promotionUrl: string;
		node: {
			__typename?: 'Bundle';
			id: string;
			clearName: string;
			icon: string;
			technicalName: string;
			bundleId: number;
			shortName: string;
			packages: Array<{
				__typename?: 'Package';
				icon: string;
				id: string;
				iconWide: string;
				clearName: string;
				packageId: number;
			}>;
		};
		offer: {
			__typename?: 'Offer';
			id: string;
			presentationType: Types.PresentationType;
			monetizationType: Types.MonetizationType;
			newElementCount?: number | null;
			retailPrice?: string | null;
			retailPriceValue?: number | null;
			userLocalCurrency?: string | null;
			retailPriceConverted?: string | null;
			currency?: string | null;
			lastChangeRetailPriceValue?: number | null;
			type: Types.OfferType;
			country: any;
			standardWebURL?: string | null;
			preAffiliatedStandardWebURL?: string | null;
			streamUrl?: string | null;
			streamUrlExternalPlayer?: string | null;
			elementCount?: number | null;
			availableTo?: any | null;
			subtitleLanguages: Array<any>;
			videoTechnology: Array<Types.VideoTechnology>;
			audioTechnology: Array<Types.AudioTechnology>;
			audioLanguages: Array<any>;
			updatedAt?: any | null;
			mediaDealId?: number | null;
			package: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				clearName: string;
				shortName: string;
				technicalName: string;
				icon: string;
				iconWide: string;
				planOffers: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
					retailPriceConverted?: string | null;
					children: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
					}>;
				}>;
			};
			plans: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
				retailPriceConverted?: string | null;
				children: Array<{
					__typename?: 'PackagePlanOffer';
					title?: string | null;
					retailPrice?: string | null;
					isTrial?: boolean | null;
					durationDays?: number | null;
					retailPriceValue?: number | null;
				}>;
			}>;
		};
	}>;
};

export type BuyBoxOffersFragment =
	| BuyBoxOffers_Episode_Fragment
	| BuyBoxOffers_Movie_Fragment
	| BuyBoxOffers_Season_Fragment
	| BuyBoxOffers_Show_Fragment;

export const BuyBoxOffersFragmentDoc = gql`
	fragment BuyBoxOffers on MovieOrShowOrSeasonOrEpisode {
		__typename
		offerCount(country: $country, platform: $platform)
		maxOfferUpdatedAt(country: $country, platform: $platform)
		totalPackages(country: $country, platform: $platform, fallbackToForeignOffers: $fallbackToForeignOffers)
		offersHistory(
			country: $country
			platform: $platform
			filterV2: {
				monetizationTypes: [FLATRATE, FLATRATE_AND_BUY, RENT, FREE, ADS, BUY, FAST]
				bestOnly: true
				preAffiliate: true
				fallbackToForeignOffers: $fallbackToForeignOffers
				excludePackages: $excludePackages
			}
		) {
			...OffersHistory
		}
		flatrate: offers(
			country: $country
			platform: $platform
			filter: {
				monetizationTypes: [FLATRATE, FLATRATE_AND_BUY, CINEMA]
				bestOnly: true
				preAffiliate: true
				fallbackToForeignOffers: $fallbackToForeignOffers
				excludePackages: $excludePackages
			}
		) {
			...TitleOffer
		}
		dvdBluray: offers(
			country: $country
			platform: $platform
			filter: {
				presentationTypes: [DVD, BLURAY, BLURAY_4K]
				preAffiliate: true
				excludePackages: $excludePackages
			}
		) {
			...TitleOffer
			offerSeasons
			minRetailPrice(country: $country, platform: $platform, language: $language)
		}
		buy: offers(
			country: $country
			platform: $platform
			filter: {
				monetizationTypes: [BUY]
				bestOnly: true
				preAffiliate: true
				fallbackToForeignOffers: $fallbackToForeignOffers
				excludePackages: $excludePackages
			}
		) {
			...TitleOffer
			offerSeasons
			minRetailPrice(country: $country, platform: $platform, language: $language)
		}
		rent: offers(
			country: $country
			platform: $platform
			filter: {
				monetizationTypes: [RENT]
				bestOnly: true
				preAffiliate: true
				fallbackToForeignOffers: $fallbackToForeignOffers
				excludePackages: $excludePackages
			}
		) {
			...TitleOffer
			offerSeasons
			minRetailPrice(country: $country, platform: $platform, language: $language)
		}
		free: offers(
			country: $country
			platform: $platform
			filter: {
				monetizationTypes: [FREE, ADS]
				bestOnly: true
				preAffiliate: true
				fallbackToForeignOffers: $fallbackToForeignOffers
				excludePackages: $excludePackages
			}
		) {
			...TitleOffer
		}
		fast: offers(
			country: $country
			platform: $platform
			filter: {
				monetizationTypes: [FAST]
				bestOnly: true
				preAffiliate: true
				fallbackToForeignOffers: $fallbackToForeignOffers
				excludePackages: $excludePackages
			}
		) {
			...FastOffer
		}
		bundles(country: $country, platform: WEB) {
			node {
				id
				clearName
				icon(profile: S100)
				technicalName
				bundleId
				shortName
				packages(country: $country, platform: $platform) {
					icon
					id
					iconWide(profile: S160)
					clearName
					packageId
				}
			}
			promotionUrl
			offer {
				...TitleOffer
			}
		}
		... on MovieOrShowOrSeason {
			promotedBundles(country: $country, platform: WEB) {
				node {
					id
					clearName
					icon(profile: S100)
					technicalName
					bundleId
					shortName
					packages(country: $country, platform: $platform) {
						icon
						id
						clearName
						packageId
						iconWide(profile: S160)
					}
				}
				promotionUrl
				offer {
					...TitleOffer
				}
			}
			promotedOffers(country: $country, platform: WEB, filter: { bestOnly: true, preAffiliate: true }) {
				...TitleOffer
				offerSeasons
				minRetailPrice(country: $country, platform: $platform, language: $language)
			}
		}
	}
	${OffersHistoryFragmentDoc}
	${TitleOfferFragmentDoc}
	${FastOfferFragmentDoc}
`;
